var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-rows: auto 1fr;\n  width: 100%;\n"], ["\n  display: grid;\n  grid-template-rows: auto 1fr;\n  width: 100%;\n"])));
var templateObject_1;
//# sourceMappingURL=CampaignOversightDetails.Styles.js.map